import styled from 'styled-components';
import { Tab, Tabset } from 'react-rainbow-components';
import ButtonIcon from 'components/ButtonIcon';
import { DIVIDER, GREY_800 } from '../../constants';

export const Container = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    border-radius: 1.5rem;
    width: 380px;
    min-width: 380px;
    height: calc(100vh - 3rem);
    margin-top: 1.5rem;
    margin-right: 1.5rem;
    padding: 0;
    box-shadow: 0px 0px 44px 0px rgba(0, 0, 0, 0.07);
    z-index: 5000;
    overflow: hidden;
`;

export const CloseButton = styled(ButtonIcon)`
    position: absolute;
    top: 1rem;
    right: 1rem;
    color: ${GREY_800};

    & svg {
        width: 1.5rem !important;
        height: 1.5rem !important;
        font-size: 1.5rem !important;
    }
`;

export const Body = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    overflow: hidden;
`;

export const TabsetContainer = styled.div`
    flex-shrink: 0;
    padding: 2.75rem 0.5rem 0;
    border-bottom: 1px solid ${DIVIDER};
    background: #fff;
`;

export const StyledTabset = styled(Tabset)`
    width: 100%;
`;

export const StyledTab = styled(Tab)`
    height: 3rem;

    button {
        padding: 0;
    }
`;

export const TabLabel = styled.span`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 0.75rem;
    font-size: 0.875rem;
    font-weight: 500;
    line-height: 1.25rem;

    svg {
        width: 1.125rem;
        height: 1.125rem;
    }
`;

export const Footer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 1.25rem;
    align-self: stretch;
`;
